import React from 'react';
import { ContentCardBanner, Typography } from '@hpi-sox/hpstellar-core';
import loadable from '@loadable/component';

import withPageComponents from '../../../page/components/with-page-components';
import { getBannerContentArray } from '../../../utility/setHtml';
import { Helpers } from '../../../core/src/helpers';

const PersonalizedProductCarousel = loadable(() =>
    Helpers.retryFunc(() => import('../../../product/components/personalized-product-carousel/visid')),
);

import './ink-toner-exclusives.less';

function InkTonerExclusives({ inkTonerExclusives, title = 'Featured products & offers' }) {
    if (!inkTonerExclusives || inkTonerExclusives.length < 1) return null;

    return (
        <>
            <PersonalizedProductCarousel
                dyName="Ink, Toner & Paper Category page - Recommendations"
                className="ink-toner-exclusive-carousel"
                productTileVariation="horizontal"
                list="category-recently-viewed"
                componentKey="categoryRecentlyViewed"
            />
            <div className="MprExclusiveSavings">
                <Typography variant="display" tag="h1" className="offers-header stellarFix">
                    {title}
                </Typography>
                <ContentCardBanner
                    orientation="horizontal"
                    banners={getBannerContentArray(inkTonerExclusives, {
                        image: { loading: 'eager' },
                        titleTypographyProps: { tag: 'h3' },
                    })}
                />
            </div>
        </>
    );
}

export default withPageComponents(InkTonerExclusives, { components: ['inkTonerExclusives'] });
